import axios from "axios";
import { API_URL } from "config/api";

const endpoint = API_URL;

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const processMonthlyData = (ventas, valueExtractor) => {
  const currentYear = new Date().getFullYear();
  const monthlyData = new Array(12).fill(0);

  ventas.forEach((venta) => {
    const date = new Date(venta.fecha_venta); // Asegurar que fecha_venta existe
    if (date.getFullYear() === currentYear) {
      const monthIndex = date.getMonth(); // 0-11
      monthlyData[monthIndex] += valueExtractor(venta);
    }
  });

  return monthlyData;
};

export const getAccionesChart = async (companyId) => {
  try {
    const [ventasRes, sucursalesRes] = await Promise.all([
      axios.get(`${endpoint}/ventas`),
      axios.get(`${endpoint}/sucursales`),
    ]);

    let ventas = Array.isArray(ventasRes.data) ? ventasRes.data : [];
    const sucursales = Array.isArray(sucursalesRes.data) ? sucursalesRes.data : [];

    if (companyId) {
      const sucursalesIds = sucursales
        .filter((s) => String(s.empresa_id) === String(companyId))
        .map((s) => s.id);
      ventas = ventas.filter((v) => sucursalesIds.includes(v.sucursal_id));
    }

    // Por "Acciones" entendemos cantidad de ventas realizadas
    const data = processMonthlyData(ventas, () => 1);

    return {
      sales: {
        labels: MONTHS,
        datasets: [{ label: "Ventas (Cantidad)", data: data }],
      },
    };
  } catch (error) {
    console.error("Error fetching acciones chart:", error);
    return {
      sales: {
        labels: MONTHS,
        datasets: [{ label: "Ventas (Cantidad)", data: new Array(12).fill(0) }],
      },
    };
  }
};

export const getIngresosConsolidadosChart = async (companyId) => {
  try {
    const [ventasRes, sucursalesRes] = await Promise.all([
      axios.get(`${endpoint}/ventas`),
      axios.get(`${endpoint}/sucursales`),
    ]);

    let ventas = Array.isArray(ventasRes.data) ? ventasRes.data : [];
    const sucursales = Array.isArray(sucursalesRes.data) ? sucursalesRes.data : [];

    if (companyId) {
      const sucursalesIds = sucursales
        .filter((s) => String(s.empresa_id) === String(companyId))
        .map((s) => s.id);
      ventas = ventas.filter((v) => sucursalesIds.includes(v.sucursal_id));
    }

    // Por "Ingresos Consolidados" entendemos suma total monetaria
    const data = processMonthlyData(ventas, (venta) => parseFloat(venta.total) || 0);

    return {
      tasks: {
        labels: MONTHS,
        datasets: [{ label: "Ingresos ($)", data: data }],
      },
    };
  } catch (error) {
    console.error("Error fetching ingresos consolidados chart:", error);
    return {
      tasks: {
        labels: MONTHS,
        datasets: [{ label: "Ingresos ($)", data: new Array(12).fill(0) }],
      },
    };
  }
};

export default {
  getAccionesChart,
  getIngresosConsolidadosChart,
};
